"use client";

import TooltipWrapper from "@/components/layout/tooltip-wrapper";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import dynamic from "next/dynamic";
import { ReactNode, useState } from "react";
import LoadingFallback from "../layout/loading-fallback";

const FeedbackForm = dynamic(() => import("./feedback-form"), { ssr: false, loading: () => <LoadingFallback /> });

type FeedbackDialogProps = {
  children: ReactNode;
};

export default function FeedbackDialog({ children }: FeedbackDialogProps) {
  const [isOpen, setIsOpen] = useState(false);

  function closeDialog() {
    setIsOpen(false);
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <TooltipWrapper text="Give feedback">
        <DialogTrigger asChild>{children}</DialogTrigger>
      </TooltipWrapper>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Give feedback</DialogTitle>
          <DialogDescription>Describe your question, problem or a suggestion</DialogDescription>
        </DialogHeader>

        <FeedbackForm closeDialogAction={closeDialog} />
      </DialogContent>
    </Dialog>
  );
}
